import { createContext } from "react";
import { ReadyFunction } from "../typing";

export interface BridgeContextType {
  ready: (callback: ReadyFunction) => void;
  support: (api: string) => Promise<boolean>;
}

const BridgeContext = createContext<BridgeContextType>({
  ready: (_callback) => {
    // throw new Error('当前不支持ready');
    console.warn('当前不支持 bridge.ready');
  },
  support: () => {
    return Promise.reject<any>('not impl');
  },
});

export default BridgeContext;
